{
  "slug": "is-iq-genetic",
  "title": "IQ आनुवंशिक है?",
  "description": "यह जानना कि कैसे जीन और पर्यावरण दोनों को संज्ञानात्मक अंतरों में योगदान देता है, और विरासत क्या है - और नहीं - मतलब है।",
  "summary": "संज्ञानात्मक क्षमता कई आनुवंशिक भिन्नताओं और कई पर्यावरणीय कारकों से प्रभावित होती है।",
  "sections": [
    {
      "heading": "कई प्रभाव, एक आईक्यू जीन नहीं",
      "paragraphs": [
        "आनुवंशिक अंतरों से संज्ञानात्मक परीक्षणों के परिणामों में भिन्नता आती है, लेकिन कोई एकल जीन नहीं होता है जो किसी व्यक्ति के आईक्यू को निर्धारित करता है।",
        "पोषण, स्वास्थ्य, शिक्षा, सुरक्षा, तनाव, पारिवारिक संसाधन और अवसर को प्रभावित कर सकता है कि कैसे संज्ञानात्मक कौशल विकसित होते हैं और व्यक्त होते हैं।"
      ]
    },
    {
      "heading": "क्या inheritability मतलब है",
      "paragraphs": [
        "आनुवंशिकता एक जनसंख्या सांख्यिकी है जो यह बताती है कि विशेष परिस्थितियों में कितनी मात्रा में आनुवंशिक भिन्नता से जुड़ी हुई है। यह यह नहीं कहता है कि किसी व्यक्ति की बुद्धि का कितना प्रतिशत आनुवंशिक है।",
        "एक लक्षण विरासत में मिल सकता है और फिर भी पर्यावरणीय परिवर्तनों के प्रति प्रतिक्रिया कर सकता है।"
      ]
    },
    {
      "heading": "निर्धारक निष्कर्षों से बचें",
      "paragraphs": [
        "एक डीएनए परिणाम किसी व्यक्ति के संज्ञानात्मक भविष्य की पूर्ण या निश्चित भविष्यवाणी नहीं कर सकता है।",
        "जिम्मेदारी से भरी व्याख्या में मानवीय मूल्य की श्रेणी के लिए कभी भी IQ का उपयोग नहीं किया जाता है।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "कितनी मात्रा में IQ विरासत में मिलता है?",
      "answer": "जनसंख्या के अनुमानों में आयु, वातावरण, जनसंख्या और अध्ययन विधि के अनुसार भिन्नता होती है।"
    },
    {
      "question": "क्या पर्यावरण IQ को प्रभावित कर सकता है?",
      "answer": "हाँ, शिक्षा, स्वास्थ्य, पोषण, तनाव, भाषा और अवसर विकास और परीक्षा प्रदर्शन को प्रभावित कर सकते हैं।"
    }
  ],
  "related": ["can-iq-change-over-time", "what-is-iq", "iq-vs-intelligence"]
}
